// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class TrackingHistoryAPI extends MainAPI {
	/**
	 * @param {*} trackingDetails contains tracking details
	 * @return {object} tracking history details
	 */
	async getTrackingDetails(trackingDetails) {
		return API.get(`${ENDPOINTS.GET_TRACKING}?${queryString.stringify(trackingDetails)}`);
	}
}
export default new TrackingHistoryAPI();
